import React from 'react';
import Footer2Component from '../commons/footer2';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Splash_Career from "../commons/splash_career";

export default class SplashHomePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            idx: 1,
            contents:
                <div className="row contents">
                    <h1>Immediate Project Support</h1>
                    <span>Get immediate support on tasks that are important,</span>
                    <span> but not the best use of time for you or your team.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                    <span className="bold">Sign up for free to get started.</span>
                </div>
        }
    }

    handleClick = (idx, evt) => {
        var contents = this.state.contents
        if (idx == 1) {
            contents =
                <div className="row contents">
                    <h1>Immediate Project Support</h1>
                    <span>Get immediate support on tasks that are important,</span>
                    <span> but not the best use of time for you or your team.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                    <span className="bold">Sign up for free to get started.</span>
                </div>
        }
        else if (idx == 2) {
            contents =
                <div className="row contents">
                    <h1>Improve Hiring Outcomes</h1>
                    <span>Project Support from college students allows you and students to mutually assess fit in a risk-free way.</span>
                    <span>This decreases the chance of making a bad hire, while improving retention.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                </div>
        }
        else if (idx == 3) {
            contents =
                <div className="row contents">
                    <h1>Enhance Your Talent  <br/>Pipeline</h1>
                    <span>As students complete projects, they can experience your company while you see their skills firsthand.</span>
                    <span>As a result, you’ll enhance your pipeline of candidates who are familiar with your organization.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                </div>
        }
        else if (idx == 4) {
            contents =
                <div className="row contents">
                    <h1>Improve Diversity</h1>
                    <span>Project support helps you find candidates from 4,000+</span>
                    <span>colleges and universities with different skills and backgrounds.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                    <span>&nbsp;</span>
                </div>
        }
        this.setState({idx: idx, contents: contents})
    }

    render() {
        //console.log('pix 1');
		if (isMobile) {
            return (
                <div id={"response-home-mobile"}>
                    <header>
                        <div className="header">
                            <div className="splash_logo">
                                <Link to="/">
                                    <img alt="VERSITY" src="/static/img/appimg/login_h_logo.png"/>
                                </Link>
                            </div>
                        </div>
                    </header>
                    <Splash_Signin
                        type="0"
                        isMobile={1}
                        openDialog={this.props.openDialog}
                        url="code/apis.php"
                    />
                    <div className={"footerClear"}>&nbsp;</div>
					<Footer2Component/>
                </div>
            )
        }

        let idx = this.state.idx
        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-splash" className="splash_wrapper">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div onClick={this.handleClick.bind(this, 1)} className={idx == 1? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon001_a.png"/>
                                <span className={idx == 1? "bold active_text" : "bold"}>Support</span>
                            </div>
                            <div onClick={this.handleClick.bind(this, 2)} className={idx == 2? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon002.png"/>
                                <span className={idx == 2? "bold active_text" : "bold"}>Hiring</span>
                            </div>
                            <div onClick={this.handleClick.bind(this, 3)} className={idx == 3? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon003.png"/>
                                <span className={idx == 3? "bold active_text" : "bold"}>Talent</span>
                            </div>
                            <div onClick={this.handleClick.bind(this, 4)} className={idx == 4? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon004.png"/>
                                <span className={idx == 4? "bold active_text" : "bold"}>Diversity</span>
                            </div>
                        </div>
                        {this.state.contents}
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/splash-home.js
 **/